// Dependencies
import styled from "styled-components";

// Utils
import { theme } from "config/theme";

export const Container = styled.div`
    display: block;
    width: 100%;

    .not-found-text {
        font-family: "Nunito", sans-serif;
        font-style: normal;
        font-size: 0.75rem;
        font-weight: 400;
        color: ${theme.colors.base[500]};

        letter-spacing: 0.01em;
        line-height: 1.333;
        padding: 0.5rem 1rem 1rem;
    }

    .webp-options-list {
        position: relative;
    }

    .webp-options-list.level-1 + .webp-options-list.level-1 {
        padding-top: 0.5rem;
        border-top: 1px solid ${theme.colors.base[200]};
    }

    .webp-options-list.level-2 + .webp-options-list.level-2::before {
        content: "";
        display: block;
        position: relative;
        top: 0px;
        left: 2rem;
        max-width: calc(100% - 2rem);
        border-top: 1px solid ${theme.colors.base[200]};
        padding-bottom: 0.5rem;
    }

    .webp-option-checkbox.level-0 {
        padding-left: 1rem;
    }
`;
